<template>
  <v-form v-model="isValid">
    <v-row no-gutters>
      <v-col cols="12" v-for="(user, key) in list" :key="key">
        <v-switch dense class="my-0 py-0" v-model="user.notification" :label="user.email" required @click="save(user)"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="text-right">
        <v-btn class="default" @click="close({reload:true})" :disabled="btnDisabled" :loading="btnDisabled">Close</v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
  export default {
    name: "notificationsUserForm",
    props:['userData', 'users'],
    data: () => {
      return {
        isValid: true,
        list: [],
        btnDisabled: false
      }
    },
    mounted() {
      this.list = JSON.parse(JSON.stringify(this.users));
    },
    computed: {},
    methods: {
      close(data) {
        this.$emit('close', data);
      },
      save(user) {
        this.btnDisabled = true;
        const payload = {
          clientId: this.userData.clientId,
          userId: user._id,
          email: user.email,
          notification: user.notification
        }
        this.$store.dispatch('updateUserNotification', payload)
        .then(response => {
          this.btnDisabled = false;
        })
      }
    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Forms/notificationsUserForm.vue